import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Heart } from "lucide-react";
import { useState } from "react";
import { SignInForm } from "./SignInForm";
import { SignUpForm } from "./SignUpForm";

export function AuthForm() {
  const [authMode, setAuthMode] = useState("signin");

  return (
    <DialogContent>
      <DialogHeader>
        <div className="mb-4 flex items-center justify-center">
          <div className="bg-linear-to-br flex h-12 w-12 items-center justify-center rounded-2xl from-indigo-500 to-blue-600 shadow-lg">
            <Heart className="h-6 w-6 text-white" />
          </div>
        </div>
        <DialogTitle className="text-2xl font-bold text-gray-900">
          Bienvenue sur Sylvain
        </DialogTitle>
        <DialogDescription className="text-gray-600">
          Connectez-vous pour commencer vos conversations
        </DialogDescription>
      </DialogHeader>
      <Tabs value={authMode} onValueChange={setAuthMode} className="w-full">
        <TabsList className="grid h-auto w-full grid-cols-2 rounded-lg bg-gray-100 p-1">
          <TabsTrigger
            value="signin"
            className="data-[state=active]:shadow-xs rounded-md px-3 py-2 text-sm text-gray-600 hover:text-gray-900 data-[state=active]:bg-white data-[state=active]:text-indigo-600"
          >
            Connexion
          </TabsTrigger>
          <TabsTrigger
            value="signup"
            className="data-[state=active]:shadow-xs rounded-md px-3 py-2 text-sm text-gray-600 hover:text-gray-900 data-[state=active]:bg-white data-[state=active]:text-indigo-600"
          >
            Inscription
          </TabsTrigger>
        </TabsList>
        <TabsContent value="signin" className="mt-6">
          <SignInForm />
        </TabsContent>
        <TabsContent value="signup" className="mt-6">
          <SignUpForm onSuccess={() => setAuthMode("signin")} />
        </TabsContent>
      </Tabs>
    </DialogContent>
  );
}
